<template>
    <div v-if="isLoggedIn" class="container page">

        <section v-if="displayPart==-1" class="card card-default">
            <div class="col-sm-8"><h5>{{awardTitle}} is Closed</h5></div>

        </section>

        <section v-if="displayPart==10" class="card card-default">
            <div class="card-header">
                <div class="row">
                    <div class="col-sm-8"><h5>{{awardTitle}}</h5></div>
                    <div class="col-sm-4">   
                    </div>
                </div>
            </div>
            <div class="card-body" >
                <div class="nomMessage">
                    <b-card no-body>
                        <b-tabs pills vertical lazy card no-nav-style nav-wrapper-class="col-12 col-md-4" content-class="col-12 col-md-8">
                            <b-tab>
                                <template v-slot:title>
                                    <div class="text-center"><b-img thumbnail fluid :src="require('../assets/image/ceostmre.jpg')" alt=""></b-img></div>
                                    <div class="mb-4 text-center ceo">Nico Conradie</div>
                                </template>
                                <b-card-text class="text-left">
                                    <p>At Santam Re, our success is built on more than strategy, performance, and results. It is built on the people who bring our culture to life every day through the choices they make, the way they collaborate, and the impact they have on those around them.</p>
                                    <p>Culture becomes real when the right behaviours are seen, repeated, and rewarded. Recognition plays a critical role in that journey. It is one of the most powerful ways we reinforce what matters most and strengthen the culture we are collectively building through ROAR.</p>
                                    <p>This platform is about celebrating the individuals and teams who consistently demonstrate the behaviours that help us succeed together. Whether it is showing courage in the face of challenges, collaborating across boundaries, delivering exceptional outcomes, or supporting colleagues to be their best, every act of recognition helps make our culture visible and meaningful.</p>
                                    <p>When we take the time to acknowledge one another, we create a workplace where people feel valued, connected, and inspired to contribute. We strengthen a sense of belonging, retain the talent and expertise that make Santam Re exceptional, and connect our everyday actions to the Santam Way and our values.</p>
                                    <p>I encourage each of you to actively embrace recognition as part of how we work. Celebrate achievements, acknowledge effort, and recognise the behaviours that reflect who we are and who we aspire to be. Together, we can create an environment where appreciation is a habit, excellence is recognised, and our ROAR culture continues to thrive.</p>
                                    <p>Thank you for the contribution you make every day and for helping to shape the future of Santam Re.</p>

                                    <div class="row">
                                        <div class="col-md-5">
                                            <p><b>Nico Conradie</b></p>
                                            <p>CEO | Santam Re</p>
                                        </div>
                                    </div>

                                </b-card-text>
                            </b-tab>

                            <hr />
                            <div class="text-right mt-3 mb-3">
                                <div v-if="isAwardRunning">
                                    <a class="btn btn-primary" href="#" @click.prevent="showNomForm()" v-b-tooltip.hover.left title="Create a new Award nomination">New Award Nomination</a>
                                </div>
                                <div v-else class="alert alert-secondary" role="alert">Nominations are now closed</div>
                            </div>
                        </b-tabs>
                    </b-card>
                </div>
            </div>
        </section>


        <template v-if="displayPart==0">
            <div class="row mb-2">
                <div class="col-sm-8">
                    <h5>{{awardTitle}}</h5>
                    Select an Award below, then complete your nomination.
                </div>
                <div class="col-sm-4 text-right">
                    <a href="#" @click.prevent="displayPart=10" class="btn btn-secondary">Back</a>
                </div>
            </div>
            <!--
    { value: '', text: '--- Please select an option ---' },
    { value: 'Individual', text: 'Individual' },
    { value: 'Team', text: 'Team' },
    { value: 'Simple Innovative Solutions', text: 'Simple Innovative Solutions' },
    { value: 'Exceptional Service', text: 'Exceptional Service < 35' },
    { value: 'General employee', text: 'General employee (non-management)' },
        -->
            <section class="card mb-4 nomAwardCategory3">
                

                <b-tabs v-model="tabIndex" lazy card nav-class="selcatNav">
                    <b-tab title="Respect" @click="awardCatSelected('Respect')">
                        <b-card-text class="text-left">
                            <div class="mb-3"><sitecode-image src="santamre_respect.jpg" class="w-100" /></div>
                            <h3>Respect - Serve</h3>
                            <hr />
                            <ul>
                                <li>We serve with empathy and kindness (all of us) and with the spirit of humanity (leaders).</li>
                                <li>We (I) treat people with kindness, respect and empathy</li>
                                <li>We (I)  courageously seek out diverse perspectives and challenge our own limiting assumptions</li>
                                <li>We (I)  are authentic and true to our values and encourage the same honesty and authenticity in others</li>
                                <li>We (I) courageously have honest and difficult conversations</li>
                                <li>We (I) prioritise the well-being of our people by promoting work-life balance and providing resources to support their mental and physical health</li>
                            </ul>
                        </b-card-text>
                    </b-tab>
                    <b-tab title="Own the outcome" @click="awardCatSelected('Own the outcome')">
                        <b-card-text class="text-left">
                            <div class="mb-3"><sitecode-image src="santamre_owntheoutcome.jpg" class="w-100" /></div>
                            <h3>Own the outcome - Live</h3>
                            <hr />
                            <ul>
                                <li>We obsess with delivering the best.</li>
                                <li>We (I) proactively move from talk to action, delivering impactful results.</li>
                                <li>We (I) make good decisions that drive excellence that enhances our strategy.</li>
                                <li>We (I) share information, skills and knowledge with each other to create better outcomes.</li>
                                <li>We (I) are empowered to take initiative and drive our own growth.</li>
                                <li>We (I) demonstrate commitment by delivering on promises and executing tasks to the best of our ability</li>
                            </ul>
                        </b-card-text>
                    </b-tab>
                    <b-tab title="Act with Courage" @click="awardCatSelected('Act with Courage')">
                        <b-card-text class="text-left">
                            <div class="mb-3"><sitecode-image src="santamre_actwithcourage.jpg" class="w-100" /></div>
                            <h3>Act with Courage - Lead / Create</h3>
                            <hr />
                            <ul>
                                <li>We dare to be bold (leaders); we embrace new opportunities with curiosity (all of us).</li>
                                <li>We (I) boldly try out and experiment with new ideas, methods, and technologies</li>
                                <li>We (I) ask powerful questions and seek new knowledge to continuously challenge the status quo</li>
                                <li>We (I) prioritise progress over perfection, and we turn failures into valuable lessons that drive/fuels future success</li>
                                <li>We (I) actively engage in and advocate for continuous learning to stay ahead of industry trends and future opportunities</li>
                            </ul>
                        </b-card-text>
                    </b-tab>
                    <b-tab title="Rise Together" @click="awardCatSelected('Rise Together')">
                        <b-card-text class="text-left">
                            <div class="mb-3"><sitecode-image src="santamre_risetogether.jpg" class="w-100" /></div>
                            <h3>Rise Together - Live</h3>
                            <hr />
                            <ul>
                                <li>We inspire greatness in our people and grow as one pride.</li>
                                <li>We (I)  invest in the development and growth of our people because it is` essential to our success and theirs</li>
                                <li>We (I) empower team members by delegating meaningful responsibilities and trusting them to make decisions</li>
                                <li>We (I) actively champion and celebrate excellence to drive our team</li>
                            </ul>
                        </b-card-text>
                    </b-tab>
                </b-tabs>
            </section>

            <section class="card card-default mt-3" v-if="fNomination.form.awardCat !== null">
                <div class="card-header">
                    <h5>Nomination for: <b class="darkShade">{{ fNomination.form.awardCat }}</b></h5>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-6"><strong>Nominee{{isNomSingleOnly ? "" : "s"}}:</strong></div>
                        <div class="col-sm-6 text-right"></div>
                    </div>
                    <div v-for="r in selectedNominees" :key="r._rowNum" class="row">
                        <template v-if="r.isEntireDivision">
                            <div class="col-1 text-right"><b-icon icon="collection" style="color:#9f34a0"></b-icon></div>
                            <div class="col" style="color:#9f34a0">Entire division: {{ r.division }}</div>
                        </template>
                        <template v-else>
                            <div class="col-1 text-right"><b-icon icon="person" style="color:#ccc"></b-icon></div>
                            <div class="col">{{ r.firstname + ' ' + r.surname }}</div>
                            <div class="col">{{ r.division }}</div>
                        </template>
                    </div>
                    <div v-if="selectedNominees.length===0" class="text-danger">Please select nominee{{isNomSingleOnly ? "" : "s"}}.</div>
                    <div class="mt-1">
                        <b-button type="button" pill @click="$bvModal.show('modalChooseNominees')" variant="primary" size="sm">{{selectedNominees.length===0 ? 'Select' : 'Update'}}  Nominee{{isNomSingleOnly ? "" : "s"}}</b-button>
                        <!--<a href="#" @click.prevent="$bvModal.show('modalChooseNominees')">Select Nominees</a>-->
                    </div>

                    <hr />
                    <b-form @submit.prevent="onSubmitAward" novalidate>
                        <!--
        <b-form-group id="groupAwardCat" label-for="selectAwardCat" label="Award Category:" :invalid-feedback="fNomination.errors.awardCat" description="">
            <b-form-select id="selectAwardCat" v-model="fNomination.form.awardCat" :options="awardCatList" value-field="value" text-field="text" :state="fNomination.state.awardCat" />
        </b-form-group>
           -->
                        <b-form-group id="groupMotivation" label-for="txtMotivation" label="Motivation:" :invalid-feedback="fNomination.errors.motivation" :description="1500-fNomination.form.motivation.length + ' characters remaining'">
                            <b-form-textarea id="txtMotivation" v-model="fNomination.form.motivation" :state="fNomination.state.motivation" placeholder="Provide a short motivation" rows="3" max-rows="5" maxlength="1500" />
                        </b-form-group>

                        <b-form-group id="groupaction" label-for="txtaction" label="Actions Taken:" :invalid-feedback="fNomination.errors.action" :description="1500-fNomination.form.action.length + ' characters remaining'">
                            <b-form-textarea id="txtaction" v-model="fNomination.form.action" :state="fNomination.state.action" placeholder="Describe action taken" rows="3" max-rows="5" maxlength="1500" />
                        </b-form-group>

                        <b-form-group id="groupimpact" label-for="txtImpact" label="Impact:" :invalid-feedback="fNomination.errors.impact" :description="1500-fNomination.form.impact.length + ' characters remaining'">
                            <b-form-textarea id="txtImpact" v-model="fNomination.form.impact" :state="fNomination.state.impact" placeholder="Impact thereof" rows="3" max-rows="5" maxlength="1500" />
                        </b-form-group>

                        <hr />
                        <template v-if="isShowEndorser">
                            <div class="row">
                                <div class="col-sm-6"><strong>Endorser for your nomination:</strong></div>
                                <div class="col-sm-6 text-right"></div>
                            </div>
                            <div v-for="r in selectedNominators" :key="r._rowNum" class="row">
                                <template v-if="r.isEntireDivision">
                                    <div class="col-1 text-right"><b-icon icon="collection" style="color:#9f34a0"></b-icon></div>
                                    <div class="col" style="color:#9f34a0">Entire division: {{ r.division }}</div>
                                </template>
                                <template v-else>
                                    <div class="col-1 text-right"><b-icon icon="person" style="color:#ccc"></b-icon></div>
                                    <div class="col">{{ r.firstname + ' ' + r.surname }}</div>
                                    <div class="col">{{ r.division }}</div>
                                </template>
                            </div>
                            <div v-if="selectedNominators.length!==2" class="text-danger">Select an endorser to support your nomination.</div>
                            <div class="mt-1"><b-button type="button" pill @click="$bvModal.show('modalChooseNominators')" variant="primary" size="sm">{{selectedNominators.length===0 ? 'Select' : 'Update'}} Endorser</b-button></div>
                            <!--<div class="text-center"><b-button type="button" @click="$bvModal.show('modalChooseNominators')" variant="primary">Select Nominators</b-button></div>-->
                            <hr />
                        </template>

                        <div class="text-right"><b-button type="submit" variant="primary">Submit</b-button></div>
                    </b-form>
                </div>
            </section>
        </template>

        <section v-if="displayPart==1" class="card card-default">
            <div class="card-header">
                <h5>{{awardTitle}}</h5>
            </div>
            <div class="card-body">
                <b-alert variant="success" show>
                    <h4 class="alert-heading">{{fNomination.form.awardCat}} Nomination</h4>
                    <p>Successfully submitted the {{fNomination.form.awardCat}} Nomination.</p>
                    <p>Your reference for this nomination is: <b>{{awardId}}</b></p>
                </b-alert>

                <b-button type="button" pill @click="displayPart=10" variant="primary">Ok</b-button>

            </div>
        </section>



        <!--
    **************************************************************************************************************************************************
                                                                M O D A L S
    **************************************************************************************************************************************************
    -->
        <!-- Modal - Nominees -->
        <b-modal id="modalChooseNominees" :title="'NOMINEE' + (isNomSingleOnly ? '' : 'S')" hide-footer size="xl" no-close-on-backdrop>
            <member-select :title="'Select Nominee' + (isNomSingleOnly ? '' : 's') + ' for the ' + fNomination.form.awardCat"
                           :selectedTitle="isNomSingleOnly ? 'Selected nominee' : 'Selected nominees'"
                           :defaultCountryCode="memberClusterCode"
                           :defaultDivisionCode="memberDivisionCode"
                           :selectedMems="selectedNominees"
                           :isCountryFixed="true"
                           :isAllowWholeDivision="false"
                           :showContinue="false"
                           excludeDivisionCode=""
                           memberType="santam-re"
                           :isSingle ="isNomSingleOnly"
                           class="mb-3" />
            <hr />
            <div class="text-right"><b-button type="submit" variant="primary" @click="$bvModal.hide('modalChooseNominees')">Done</b-button></div>
        </b-modal>

        <!-- Modal - Nominators -->
        <b-modal id="modalChooseNominators" title="NOMINATORS" hide-footer size="xl" no-close-on-backdrop>
            <member-select title="Select an endorser to support your nomination"
                           selectedTitle="Selected endorser to support your nomination"
                           :defaultCountryCode="memberClusterCode"
                           :defaultDivisionCode="memberDivisionCode"
                           :selectedMems="selectedNominators"
                           :isCountryFixed="true"
                           :isAllowWholeDivision="false"
                           :showContinue="false"
                           :isSingle="true"
                           memberType="santam-re"
                           class="mb-3" />
            <hr />
            <div class="text-right"><b-button type="submit" variant="primary" @click="$bvModal.hide('modalChooseNominators')">Done</b-button></div>
        </b-modal>


    </div>

</template>

<script>
    // @ is an alias to /src
    //import HelloWorld from '@/components/HelloWorld.vue'
    import SitecodeImage from '@/components/SitecodeImage';
    import axios from 'axios'
    //import sjData from '@/sjUtilData'
    import MemberSelect from '@/components/MemberSelect';
	//import ContentDb from '@/components/ContentDb';



    export default {
        name: 'SanlamAward',
        components: { MemberSelect, SitecodeImage },//, ContentDb },
        data() {
            return {
                isAwardRunning: true, //when false, nominations are closed

                awardTitle: "Santam Re Recognition Awards",
                displayPart: 10, //Sanlam Life &amp; Savings CEO Award:   -1: Closed  10:Open
                fNomination: { 
                    form: { awardCat: 'Respect', motivation: '', action: '', impact: '' }
                },
                tabIndex: 0,

                selectedNominees: [],
                selectedNominators: [],

                roles: { ca: false, cc: false, idea: false, inv: false },

                reportTitle: '',
                currentIdeaRowNum: null,
                modalPart: 0,

                //awardCatList: [
                //    { value: '', text: '--- Please select an option ---' },
                //    { value: 'One Sanlam Experience Award: Emerging', text: 'One Sanlam Experience Award: Emerging' },
                //    { value: 'Innovation', text: 'Innovation' },
                //    { value: 'Santam Experience', text: 'Santam Experience' },
                //    { value: 'Collaboration', text: 'Collaboration' },
                //    { value: 'Everyday Hero', text: 'Everyday Hero' },
                //    { value: 'Rising Star', text: 'Rising Star' }
                //],

                awardId: 0

            }
        },
        computed: {
            isLoggedIn() {
                return this.$store.state.isLoggedIn && this.memberDivisionCode == 'stm_7137'; //Only stm_7137
            },
            countryList() {
                if (this.isCountryFixed) { //only show the default cluster.
                    return this.$store.state.countryList.filter(country => country.countryCode === this.defaultCountryCode);
                } else {
                    return [{ countryCode: null, country: '-- Please select a Cluster--', disabled: true }]
                        .concat(this.$store.state.countryList);
                }
            },
            memberClusterCode() {
                return this.$store.state.memberStore.member.clusterCode
            },
            memberDivisionCode() {
                return this.$store.state.memberStore.member.divisionCode
            },
            currentIdea() {
                if (this.currentIdeaRowNum === null) return null;
                return this.ideas[this.currentIdeaRowNum];
            },
            isNomSingleOnly() {
                return false; //Allow multiple nominees for all award categories.

                // switch (this.fNomination.form.awardCat) {
                //     case "Rise Together":
                //     case "Suiderkruis":
                //         return false; //team
                //     default:
                //         return true; //single
                // }

                //return false;// !this.fNomination.form.awardCat.startsWith("Innovation Award");

                //return this.fNomination.form.awardCat == 'Leadership with Excellence'
                //    || this.fNomination.form.awardCat == 'Rising Star'
                //    || this.fNomination.form.awardCat == 'Everyday Hero';
            },
            isShowEndorser() {
                return false;
                // switch (this.fNomination.form.awardCat) {
                //     case "iLanga":
                //     case "Act with Courage":
                //     case "Rise Together":
                //         return false;
                //     default:
                //         return true;
                // }
            }

        },
        created() {
            //formSetState must be called on creation, to ensure all fields are setup
            this.formSetState(this.fNomination, true, true) //formObj, resetState, resetForm

            this.$store
                .dispatch('getDivisionList', {})
                .then(() => { 

                })
                .catch((error) => {
                    this.msgBox(error.response.data.message ? error.response.data.message : ('An error has occured: ' + JSON.stringify(error)));
                });


        },
        mounted() {

        },
        methods: {
            showNomForm() {
                this.formSetState(this.fNomination, true, true) //formObj, resetState, resetForm
                this.displayPart = 0;
                this.$nextTick(() => {
                    this.tabIndex = 0; //Select first tab
                    this.awardCatSelected('Respect'); //ensure got awardCat for first tab
                });
            },
            msgBox(msg, title) {
                this.$bvModal.msgBoxOk(msg, { title: typeof title === 'undefined' ? 'Please note:' : title, centered: true })
            },

            //*** formStatusUpdate - used to display form errors.
            //Ensure this.form contains the list of fields.
            //Call  formStatusUpdate(true) to initialise/clear the form errors.
            //formObject is the object that contains the following objects:  .form, .formState, .formErrors
            formSetState(formObj, resetState, resetForm) {
                if (typeof resetState === 'undefined') resetState = false;
                if (typeof resetForm === 'undefined') resetForm = false;
                if (typeof formObj.init === 'undefined') formObj.init = { ...formObj.form }; //Initialise .formInit object to be a copy of .form object.
                if (typeof formObj.errors === 'undefined') this.$set(formObj, 'errors', {}); //use this.$set  to make errors object reactive
                if (typeof formObj.state === 'undefined') this.$set(formObj, 'state', {});   //use this.$set  to make state object reactive

                if (resetState || resetForm) {
                    if (resetForm) formObj.form = { ...formObj.init }; //copy .init to .form

                    formObj.errors = {}; //reset formErrors object
                    formObj.state = {};
                }

                //update formState
                var fields = Object.getOwnPropertyNames(formObj.form);
                for (let i = 0; i < fields.length; i++) {
                    let field = fields[i];
                    if (resetState) {
                        formObj.state[field] = null;
                    } else if (typeof formObj.errors[field] === 'undefined' || formObj.errors[field] === '') {
                        formObj.state[field] = true;
                    } else {
                        formObj.state[field] = false;
                    }
                }
            },


            awardCatSelected(awardCat) {
                this.fNomination.form.awardCat = awardCat;
                this.selectedNominees = [];
            },

            onSubmitAward() {
                try {

                    

                    if (this.selectedNominees.length === 0) {
                        this.msgBox('Please select at least one nominee.', 'Nominees are required');
                        return;
                    }

                    if (this.isNomSingleOnly && this.selectedNominees.length !== 1) {
                        this.msgBox('Only a single nominee may be selected.', 'Single Nominees');
                        return;
                    }

                    let nominators;
                    if (this.isShowEndorser) {
                        nominators = this.selectedNominators.filter(item => !item.isEntireDivision);
                        if (nominators.length == 0) {
                            this.msgBox('Please select an endorser.', 'An endorser is required');
                            return;
                        }
                    } else {
                        this.selectedNominators = [];
                        nominators = [];
                    }

                    this.formSetState(this.fNomination, true);//formObj, resetState, resetForm

                    this.fNomination.form.nominees = this.selectedNominees.map(item => item.isEntireDivision ? 'div:' + item.entireDivisionCode : item.memberId);

                    var payload = { ...this.fNomination.form, awardType: "santam-re" }
                    
                    if (nominators.length !== 0) {
                        payload.endorserMemberId = nominators[0].memberId;
                    }

                    return axios
                        .post(
                            '/api/SanlamAward/newnomination',
                            payload
                        )
                        .then(({ data }) => {
                            console.log(data);

                            const er = data.errorMessage;
                            this.awardId = data.awardId;

                            if (data.awardId == 0) {
                                this.msgBox('An unexpected error occured: ' + er)
                            } else {
                                this.displayPart = 1;
                                //this.msgBox('Successfully submitted nomination');
                            }
                        })
                        .catch((error) => {
                            this.msgBox(error.response.data.message ? error.response.data.message : ('An error has occured: ' + JSON.stringify(error.response.data)));
                            if (error.response.data.formErrors) {
                                this.fNomination.errors = error.response.data.formErrors;
                                this.formSetState(this.fNomination);
                            }
                        })
                        ;
                } catch (err) {
                    this.msgBox(err.message, 'An unexpected error occured submitting the nomination');
                }
            },

        }




    }
</script>
